const STR_LIMIT = 18;

export default function textLimit(value, limit = STR_LIMIT) {
  if (value.length > limit) {
    return `${value.substring(0, limit)}...`;
  }

  return value;
}
